export const mainnetContractAddress = "0x10e2eDba3950d4C182B605b3240e74c40Ac0dC3D";

export const testnetContractAddress="0x4b5e01650823dC11c19Dc9EF792049E0CCA6AE7F";

export const contractAddress = mainnetContractAddress; 
